// Широкий экран: панели над картой плавают и перетаскиваются; на телефоне
// они стоят на месте (или становятся нижним листом).

import { useEffect, useState } from 'react'

export const WIDE_QUERY = '(min-width: 768px)'

export function useWide(): boolean {
  const [wide, setWide] = useState(() => typeof window !== 'undefined' && window.matchMedia(WIDE_QUERY).matches)
  useEffect(() => {
    const mq = window.matchMedia(WIDE_QUERY)
    const on = () => setWide(mq.matches)
    mq.addEventListener('change', on)
    return () => mq.removeEventListener('change', on)
  }, [])
  return wide
}
